/**
 * Cart Minimum Order Value
 *
 * Blocks reaching checkout - NOT adding to cart - whenever the cart
 * subtotal is under MIN_SUBTOTAL_CENTS. Shows a message and disables the
 * checkout button on both the cart drawer and the /cart page.
 *
 * Deliberately does not touch /cart/add in any way: the previous minimum
 * order value rule (in the BoomGate app) was scoped per-product instead
 * of per-cart, so it rejected individual in-stock products at add-to-cart
 * time with a 422 that looked like a false "out of stock" error. This
 * script only gates the checkout button itself, once the real cart total
 * is known, so a low subtotal can never surface as a stock problem.
 *
 * Runs site-wide (included from layout/theme.liquid, same as
 * bundle-gift-guard.js) because the cart drawer can open from any page,
 * not just /cart. Re-evaluates on the theme's cart-update event and on a
 * fixed poll, since Dawn's own AJAX section re-renders replace the
 * checkout button element entirely (losing any state set on the old one).
 */
(function () {
  var MIN_SUBTOTAL_CENTS = 5000; // 50.00 RON
  var MESSAGE_TEXT =
    'Valoarea minimă a produselor trebuie să fie de 50 de lei pentru a finaliza comanda.';
  var MESSAGE_CLASS = 'cart-min-value-message';
  var POLL_MS = 2000;
  var DEBOUNCE_MS = 300;
  var CART_URL = '/cart.js';

  var debounceTimer = null;

  function scheduleCheck() {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(runCheck, DEBOUNCE_MS);
  }

  function runCheck() {
    fetch(CART_URL)
      .then(function (response) {
        return response.json();
      })
      .then(applyGate)
      .catch(function () {});
  }

  function buildMessageEl() {
    var el = document.createElement('div');
    el.className = MESSAGE_CLASS;
    el.setAttribute('role', 'alert');
    el.textContent = MESSAGE_TEXT;
    el.style.color = '#c72020';
    el.style.background = 'rgba(199, 32, 32, 0.08)';
    el.style.border = '1px solid rgba(199, 32, 32, 0.25)';
    el.style.borderRadius = '0.6rem';
    el.style.padding = '1rem 1.2rem';
    el.style.fontSize = '1.3rem';
    el.style.lineHeight = '1.4';
    el.style.margin = '0 0 1rem';
    return el;
  }

  // Accelerated/dynamic checkout buttons (Shop Pay, PayPal, etc.) bypass
  // our own <button> entirely, so they need to be hidden separately -
  // disabling #checkout alone would not stop them.
  function gateDynamicButtons(container, belowMinimum) {
    if (!container) return;
    var dynamicButtons = container.querySelector('.cart__dynamic-checkout-buttons');
    if (!dynamicButtons) return;
    dynamicButtons.style.display = belowMinimum ? 'none' : '';
  }

  function gateButton(button, belowMinimum) {
    if (!button) return;
    var ctaContainer = button.closest('.cart__ctas') || button.parentElement;
    var footer = button.closest('.cart-drawer__footer, .cart__footer') || ctaContainer;
    var existingMessage = footer.querySelector('.' + MESSAGE_CLASS);

    if (belowMinimum) {
      button.setAttribute('disabled', 'disabled');
      button.setAttribute('aria-disabled', 'true');
      button.dataset.minValueDisabled = 'true';
      if (!existingMessage) {
        ctaContainer.insertBefore(buildMessageEl(), button.parentElement === ctaContainer ? button : ctaContainer.firstChild);
      }
    } else {
      // Only re-enable if we were the ones who disabled it - leave the
      // theme's own empty-cart disabling (cart == empty) alone.
      if (button.dataset.minValueDisabled === 'true') {
        button.removeAttribute('disabled');
        button.removeAttribute('aria-disabled');
        delete button.dataset.minValueDisabled;
      }
      if (existingMessage) existingMessage.remove();
    }

    gateDynamicButtons(footer, belowMinimum);
  }

  function applyGate(cart) {
    if (!cart) return;
    var belowMinimum = cart.item_count > 0 && cart.total_price < MIN_SUBTOTAL_CENTS;

    gateButton(document.querySelector('#checkout'), belowMinimum);
    gateButton(document.querySelector('#CartDrawer-Checkout'), belowMinimum);
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      scheduleCheck();
    });
  }

  // Safety net: poll on a fixed interval regardless of any event system,
  // mirroring bundle-gift-guard.js's approach for the same reasons (the
  // Samita Order Limits app hooks into the same event bus and there's no
  // guarantee the theme's own cart-update event always fires cleanly).
  setInterval(scheduleCheck, POLL_MS);

  document.addEventListener('DOMContentLoaded', scheduleCheck);
})();
